import { setMilliseconds, setSeconds, setMinutes, setHours, isDate, isValid } from 'date-fns';
import { sortBy, reverse, isNil, isArray, isEmpty } from 'lodash';
import NumberFormat from 'format-num';

/**
 * Wrapper function to check if value is null, if so, return the default value provided.
 * @param {Any} value Value.
 * @param {Any} def Defualt value.
 */
export function _val(value, def = '') {
    return !isNil(value) ? value : def;
}

/**
 * Wrapper function to check if value is null, if so, return the default value provided.
 * @param {Any} value Value.
 * @param {Any} def Defualt value.
 */
export function _valSupplierEmail(value) {
    if (!isNil(value)) {
        if (isJson(value)) {
            return JSON.parse(value);
        } else if (isArray(value)) {
            return value;
        } else if (isEmpty(value)) {
            return [];
        } else {
            return [value];
        }
    }

    return [];
}

export function isJson(value) {
    try {
        JSON.parse(value);
    } catch (e) {
        return false;
    }
    return true;
}
/**
 * Function to define a string in a pattern to be used in all search inputs.
 * @param {String} str term to search.
 */
export function toSearchableString(str) {
    return str ? str.trim().toLowerCase() : '';
}

/**
 * Wrapper function to modify and array with search by an child ID.
 * @param {Array} array Array to search.
 * @param {Any} id ID to be searched in the child.
 * @param {Function} cb Callback to be called when the ID was found.
 */
export function mapById(array, id, cb) {
    return array.map(function(item) {
        if (item.id !== id) {
            return item;
        }
        return cb(item);
    });
}

/**
 * onlyNumberFilter must:
 * - call handle if the e || e.target is a number
 */
export const onlyNumberFilter = handle => (e, target) => {
    let { value } = target || e.target;
    value = !value ? '' : Number(value);
    if (!isNaN(value)) {
        if (target) {
            target.value = value;
        }
        if (e.target) {
            e.target.value = value;
        }
        return handle(e, target);
    }
};

/**
 * Helper function to create a date from UTC.
 */
export function fromUTC(date, zeroTime = false) {
    const d = new Date();
    d.setFullYear(date.getUTCFullYear());
    d.setMonth(date.getUTCMonth());
    d.setDate(date.getUTCDate());
    if (zeroTime) {
        d.setHours(0);
        d.setMinutes(0);
        d.setSeconds(0);
        d.setMilliseconds(0);
    } else {
        d.setHours(date.getUTCHours());
        d.setMinutes(date.getUTCMinutes());
        d.setSeconds(date.getUTCSeconds());
        d.setMilliseconds(date.getUTCMilliseconds());
    }
    return d;
}

/**
 * Helper function to zero time in a date object.
 * @param {Date} date object to manipulate.
 */
export function zeroTime(date) {
    return setMilliseconds(setSeconds(setMinutes(setHours(date, 0), 0), 0), 0);
}

/**
 * Helper function to return an time without timezone.
 * @param {Date} date object to manipulate.
 */
export function utcTime(date = new Date()) {
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0));
}

/**
 * Check if a given date is valid.
 * @param {Date} date object to be validated.
 */
export function isValidDate(date) {
    return isDate(date) && isValid(date);
}

/**
 * Helper function to filter an array by some column.
 * @param {Array} data array to be sorted.
 * @param {Object} sort helper object to aux the sort function.
 */
export function sortData(data, sort) {
    const { column, direction } = sort;
    data = sortBy(data, [column]);
    if (direction === 'descending') {
        data = reverse(data);
    }
    return data;
}

/**
 * Helper function to format a number to a "20,00" or "20.000" format.
 * @param {Number} value
 */
export function formatNumber(value) {
    return NumberFormat(value, { minFraction: 1, maxFraction: 1 })
        .replace(/,/g, '#')
        .replace(/\./g, ',')
        .replace(/#/g, '.');
}

/**
 * Helper function to sort arrays of strings.
 * @param {String} a String A.
 * @param {String} b String B.
 */
export function sortString(a, b) {
    if (!a && b) {
        return 1;
    } else if (!b && a) {
        return -1;
    } else if (!a && !b) {
        return 0;
    }

    let strA = a
        .toUpperCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
    let strB = b
        .toUpperCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
    if (strB > strA) {
        return -1;
    }
    if (strA > strB) {
        return 1;
    }
    return 0;
}

/**
 * Helper function to sort arrays of numbers.
 * @param {Number} a Number A.
 * @param {Number} b Number B.
 */
export function sortNumber(a, b) {
    return a - b;
}
